import { useState } from "react";
import Button from "../../../components/Button/Button";
import { Resubscribe } from "../../../services/emailresubscribe.service";
import { handleMessage } from "../../../utils/handleMessagePopup";
import "./EmailResubscribePage.css";
import { useLocation } from "react-router-dom";

function EmailResubscribePage() {
  const [state, setState] = useState({
    isButtonLoading: false,
  });
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email");
  const type = queryParams.get("type");
  const is_already = queryParams.get("is_already") === "true";

  const handleResubscribe = async () => {
    setState((prev) => ({ ...prev, isButtonLoading: true }));

    try {
      const response = await Resubscribe({ email, type });

      if (response?.error == null) {
        handleMessage("Request submitted successfully");
      } else {
        handleMessage("Something went wrong. Please try again later.");
      }
    } catch (error) {
      handleMessage("Something went wrong. Please try again later.");
    } finally {
      setState((prev) => ({ ...prev, isButtonLoading: false }));
    }
  };

  return (
    <>
      {state.isButtonLoading ? (
        <div className="loader">
          <div className="spinner"></div>
        </div>
      ) : (<></>)}
        <div className="container">
          <div className="email-page">
            <div className="font-500-44 mb-4 email-h1">
              {is_already
                ? "You are unsubscribed"
                : "We sent one too many, didn't we?"}
            </div>
            <div className="font-500-26 font-inter email-h2">
              {is_already
                ? "You are already unsubscribed from Fan1 emails"
                : "You are unsubscribed from Fan1 emails."}
            </div>
            <div className="font-300-15 mb-5">
              <div className="mt-2">
                {is_already
                  ? "Communication preferences can take several days to update. To manage your notification settings"
                  : "If this was a mistake, you can click below or adjust your"}{" "}
                <a href="/settings/notifications" className="White">
                  {is_already ? "click here." : "email preferences."}
                </a>
              </div>
            </div>
            <div className="center-mobile">
              <Button
                label="Resubscribe to Fan1 emails"
                className="font-500-18 email-btn"
                onClick={handleResubscribe}
              />
            </div>
          </div>
        </div>
      
    </>
  );
}

export default EmailResubscribePage;
